export default "/fonts/vendor/katex/dist/KaTeX_Main-Regular.woff2?f650f111a3b890d116f1ba740b7e3de3";